import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import { Conditional } from "../Conditional/index.es.js";
import "../Icon/index.es.js";
import { IconLoader } from "../icons/IconLoader/index.es.js";
import './styles.css';const Button = ({
  as,
  children = "Button component",
  color = "default",
  disabled = false,
  expand,
  href,
  htmlType = "button",
  loading = false,
  onClick,
  size = "medium",
  type = "primary",
  target,
  negative = false,
  btnText = false,
  round = false,
  className,
  borderWidth = "medium",
  elementRef,
  ...props
}) => {
  const buttonClasses = classNames("au-btn", {
    [`au-btn--type-${type}`]: !!type,
    [`au-btn--size-${size}`]: !!size,
    [`au-btn--expand-${expand}`]: !!expand,
    [`au-btn--color-${color}`]: !!color,
    "au-btn--negative": !!negative,
    "au-btn--disabled": !!disabled,
    "au-btn--loading": !!loading,
    [`au-btn--round-${size}`]: !!round,
    "btn-text": !!btnText,
    [`au-btn--border-${borderWidth}`]: !!borderWidth,
    [className ?? ""]: typeof className === "string"
  });
  function handleClick(e) {
    if (!disabled && !!onClick) onClick(e);
  }
  if (as === "a") {
    return /* @__PURE__ */ jsx(
      "a",
      {
        className: buttonClasses,
        href,
        target,
        ref: elementRef,
        ...props,
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: buttonClasses,
      onClick: handleClick,
      type: htmlType,
      ref: elementRef,
      disabled: disabled || loading,
      ...props,
      children: /* @__PURE__ */ jsx(
        Conditional,
        {
          condition: loading,
          renderIf: /* @__PURE__ */ jsx(IconLoader, {}),
          renderElse: children
        }
      )
    }
  );
};
export {
  Button
};
//# sourceMappingURL=index.es.js.map
